var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { position: "relative" } }, [
    _vm.label
      ? _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input input--text", class: _vm.stateClasses },
      [
        _vm.type === "checkbox"
          ? _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentValue,
                      expression: "currentValue"
                    }
                  ],
                  attrs: {
                    "aria-labelledby": _vm.id,
                    disabled: _vm.disabled,
                    id: _vm.id,
                    placeholder: _vm.disabled ? "Disabled" : _vm.placeholder,
                    maxlength: _vm.maxlength,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.currentValue)
                      ? _vm._i(_vm.currentValue, null) > -1
                      : _vm.currentValue
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.currentValue,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.currentValue = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.currentValue = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.currentValue = $$c
                      }
                    }
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            )
          : _vm.type === "radio"
          ? _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentValue,
                      expression: "currentValue"
                    }
                  ],
                  attrs: {
                    "aria-labelledby": _vm.id,
                    disabled: _vm.disabled,
                    id: _vm.id,
                    placeholder: _vm.disabled ? "Disabled" : _vm.placeholder,
                    maxlength: _vm.maxlength,
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.currentValue, null) },
                  on: {
                    change: function($event) {
                      _vm.currentValue = null
                    }
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            )
          : _c(
              "input",
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentValue,
                      expression: "currentValue"
                    }
                  ],
                  attrs: {
                    "aria-labelledby": _vm.id,
                    disabled: _vm.disabled,
                    id: _vm.id,
                    placeholder: _vm.disabled ? "Disabled" : _vm.placeholder,
                    maxlength: _vm.maxlength,
                    type: _vm.type
                  },
                  domProps: { value: _vm.currentValue },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.currentValue = $event.target.value
                    }
                  }
                },
                "input",
                _vm.$attrs,
                false
              )
            ),
        _vm._v(" "),
        _c("icon", { attrs: { name: _vm.iconName } }),
        _vm._v(" "),
        _c("span", {
          staticClass: "input__underline",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        !_vm.valid
          ? _c(
              "div",
              { staticClass: "input__error", attrs: { role: "alert" } },
              [_vm._t("error")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "input__info" }, [_vm._t("info")], 2)
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }